import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import { addDays, format, parseISO } from "date-fns";

export function ScheduleComparisonHeader({ runLabel, weekStart, onClose, busy, id, title = "Compare schedules" }) {
  const start = weekStart instanceof Date ? weekStart : weekStart ? parseISO(weekStart) : null;
  const end = start ? addDays(start, 6) : null;
  const sameYear = start?.getFullYear() === end?.getFullYear();
  const sameMonth = sameYear && start?.getMonth() === end?.getMonth();
  const dateRange = start
    ? `${format(start, sameYear ? "MMM d" : "MMM d, yyyy")}–${format(end, sameMonth ? "d, yyyy" : "MMM d, yyyy")}`
    : runLabel;
  return <header className="flex shrink-0 items-center justify-between gap-4 border-b border-slate-200 px-5 py-3 sm:px-3">
    <div>
      <h2 id={id} className="text-xl font-semibold text-slate-900">{title}</h2>
      <p className="text-sm text-slate-500">{dateRange}</p>
      {weekStart && <span className="sr-only">{runLabel}</span>}
    </div>
    <button type="button" aria-label="Close comparison" onClick={onClose} disabled={busy}
      className="flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 focus-visible:outline-violet-600 disabled:opacity-50">
      <CloseIcon fontSize="small" />
    </button>
  </header>;
}

export function ScheduleComparisonActions({ onCancel, onApply, busy, disabled }) {
  return <footer className="shrink-0 border-t border-slate-200 bg-white px-5 py-3 sm:px-3">
    <div className="flex items-center justify-end gap-3">
        <button type="button" onClick={onCancel} disabled={busy}
          className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 focus-visible:outline-violet-600 disabled:opacity-50">Cancel</button>
        <button type="button" onClick={onApply} disabled={busy || disabled}
          className="flex min-w-[128px] items-center justify-center gap-2 rounded-lg bg-violet-700 px-4 py-2 text-sm font-semibold text-white hover:bg-violet-800 focus-visible:outline-violet-600 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50">
          {busy && <CircularProgress size={14} sx={{ color: "white" }} />}
          {busy ? "Applying…" : "Apply changes"}
        </button>
    </div>
  </footer>;
}
